'use client';
import * as React from 'react';
export const InteractionTagContext = /*#__PURE__*/ React.createContext(undefined);
const interactionTagContextDefaultValue = {
    appearance: 'filled',
    disabled: false,
    handleTagDismiss: ()=>({}),
    handleTagSelect: ()=>({}),
    interactionTagPrimaryId: '',
    selected: false,
    selectedValues: [],
    shape: 'rounded',
    size: 'medium',
    value: ''
};
export const InteractionTagContextProvider = InteractionTagContext.Provider;
export const useInteractionTagContext_unstable = ()=>{
    var _React_useContext;
    return (_React_useContext = React.useContext(InteractionTagContext)) !== null && _React_useContext !== void 0 ? _React_useContext : interactionTagContextDefaultValue;
};
